import { t } from 'i18next';
import { RecruitmentScheduleDay } from '../../../types/recruitmentTypes';
import { FilterOps, FilterTypes } from './types';

export const COMMON_GLOBAL_SEARCH_SELECT_PROPS = {
  size: 'small',
  theme: 'light',
  styles: {
    control: (base: any) => ({ ...base, minWidth: 200 })
  }
} as const;

const getDayLabel = (day: RecruitmentScheduleDay): string => {
  switch (day) {
    case RecruitmentScheduleDay.AnyDay:
      return t('advanced-search:schedule.days.anyday');
    case RecruitmentScheduleDay.Weekdays:
      return t('advanced-search:schedule.days.weekdays');
    case RecruitmentScheduleDay.Weekends:
      return t('advanced-search:schedule.days.weekends');
    case RecruitmentScheduleDay.Sunday:
      return t('advanced-search:schedule.days.sunday');
    case RecruitmentScheduleDay.Monday:
      return t('advanced-search:schedule.days.monday');
    case RecruitmentScheduleDay.Tuesday:
      return t('advanced-search:schedule.days.tuesday');
    case RecruitmentScheduleDay.Wednesday:
      return t('advanced-search:schedule.days.wednesday');
    case RecruitmentScheduleDay.Thursday:
      return t('advanced-search:schedule.days.thursday');
    case RecruitmentScheduleDay.Friday:
      return t('advanced-search:schedule.days.friday');
    case RecruitmentScheduleDay.Saturday:
      return t('advanced-search:schedule.days.saturday');
    default:
      const _exhaustive: never = day;
      return _exhaustive;
  }
};

export const getDaySelectOptions = (): { value: RecruitmentScheduleDay; label: string }[] => [
  {
    value: RecruitmentScheduleDay.AnyDay,
    label: getDayLabel(RecruitmentScheduleDay.AnyDay)
  },
  {
    value: RecruitmentScheduleDay.Weekdays,
    label: getDayLabel(RecruitmentScheduleDay.Weekdays)
  },
  {
    value: RecruitmentScheduleDay.Weekends,
    label: getDayLabel(RecruitmentScheduleDay.Weekends)
  },
  {
    value: RecruitmentScheduleDay.Sunday,
    label: getDayLabel(RecruitmentScheduleDay.Sunday)
  },
  {
    value: RecruitmentScheduleDay.Monday,
    label: getDayLabel(RecruitmentScheduleDay.Monday)
  },
  {
    value: RecruitmentScheduleDay.Tuesday,
    label: getDayLabel(RecruitmentScheduleDay.Tuesday)
  },
  {
    value: RecruitmentScheduleDay.Wednesday,
    label: getDayLabel(RecruitmentScheduleDay.Wednesday)
  },
  {
    value: RecruitmentScheduleDay.Thursday,
    label: getDayLabel(RecruitmentScheduleDay.Thursday)
  },
  {
    value: RecruitmentScheduleDay.Friday,
    label: getDayLabel(RecruitmentScheduleDay.Friday)
  },
  {
    value: RecruitmentScheduleDay.Saturday,
    label: getDayLabel(RecruitmentScheduleDay.Saturday)
  }
];

export const DEFAULT_GLOBAL_SEARCH_PAGE_SIZE = 100;
export const GLOBAL_SEARCH_DEBOUNCE_MS = 500;

export const MULTI_VALUE_TYPES = new Set([FilterTypes.RANGE, FilterTypes.DATE_RANGE, FilterTypes.WEEKDAY]);
export const EQ_ONLY = [FilterOps.EQ];
export const EQ_OPS = [FilterOps.EQ, FilterOps.NEQ];
export const RANGE_OPS = [FilterOps.GT, FilterOps.LT];

export const getMemberCategories = () => [
  {
    displayName: t('advanced-search:member-categories.all-members.display-name'),
    singularName: t('advanced-search:member-categories.all-members.singular-name'),
    filterPath: 'all'
  },
  {
    displayName: t('advanced-search:member-categories.mains.display-name'),
    singularName: t('advanced-search:member-categories.mains.singular-name'),
    filterPath: 'mains'
  },
  {
    displayName: t('advanced-search:member-categories.alts.display-name'),
    singularName: t('advanced-search:member-categories.alts.singular-name'),
    filterPath: 'alts'
  }
];
